import { CapoPlugin } from "/tmp/build_58fff9e7/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];